import * as Yup from "yup";
import { pattern, EmailIDPattern, passwordWithoutSpace } from "./ValidationPattern.const";

export const completeProfileSchema =  Yup.object().shape({
    firstName: Yup.string()
        .min(3, "Name must be at least 3 characters long")
        .max(50, "Name must not exceed 50 characters")
        .required("First name is required"),
    lastName: Yup.string()
        .min(3, "Name must be at least 3 characters long")
        .max(50, "Name must not exceed 50 characters")
        .required("Last name is required"),
    email: Yup.string()
        .matches(EmailIDPattern, "Enter valid email")
        .required("Email ID is required"),
    street: Yup.string()
        .matches(pattern.AlphaNumericForAddress, "Enter valid details")
        .min(2, "Address must be at least 2 characters long")
        .max(100, "Address must not exceed 100 characters")
        .required("Address is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("City is required"),
    zipCode: Yup.string().required("Zipcode is required"),
});

export const ForgotPasswordSchema = Yup.object().shape({
    username: Yup.string()
      .matches(EmailIDPattern, "Enter valid email")
      .required("Enter valid email"),
});

export const LoginSchema = Yup.object().shape({
    username: Yup.string()
      .matches(EmailIDPattern, "Enter valid email")
      .required("Enter valid email"),
    password: Yup.string()
    .matches(passwordWithoutSpace, "Enter valid password")
    .required("Enter valid password"),
});

export const phoneNumberSchema = Yup.object().shape({
    phoneNumber: Yup.string()
        .min(10, "Phone number must be exactly 10 digits long.")
        .max(10, "Phone number must be exactly 10 digits long.")
        .required("Phone Number is required"),
});

export const SetPasswordSchema = Yup.object().shape({
    password: Yup.string()
      .matches(/^(?=.*[a-z])(?=.*[A-Z])(?!.* ).{8,}$/g, "Invalid Password")
      .required("Enter valid password"),
    confirmPassword: Yup.string()
      .matches(/^(?=.*[a-z])(?=.*[A-Z])(?!.* ).{8,}$/g, "Invalid Password")
      .required("Enter valid password"),
});